import {
  Dialog,
  DialogActionsWrapper,
} from "@/design-system/components/Dialog/Dialog";
import { Button } from "@/design-system/components/Button/Button";
import { User } from "@/components/users/types";

import { UserEnvironmentSelectorUsersTable } from "../UserEnvironmentSelectorUsersTable";

type UserEnvsMap = Record<string, Record<string, Record<string, boolean>>>;

type EnvironmentAccessModalProps = {
  open: boolean;
  member: User | null;
  onClose: () => void;
  loadingUserEnvs: boolean;
  userEnvs: UserEnvsMap | null;
  enableToggle: boolean;
  onUserEnvAccessUpdate: (
    uid: string,
    projID: string | null,
    envID: string | null,
    hasAccess: boolean,
  ) => void;
};

export function EnvironmentAccessModal({
  open,
  member,
  onClose,
  loadingUserEnvs,
  userEnvs,
  enableToggle,
  onUserEnvAccessUpdate,
}: EnvironmentAccessModalProps) {
  return (
    <Dialog
      onOpenChange={onClose}
      open={open}
      title="Environment access"
      contentProps={{
        className: "w-2xl",
      }}
    >
      <div className="flex flex-col gap-4">
        <div>
          <p className="font-semibold">Email</p>
          <p>{member?.email}</p>
        </div>
        {member && (
          <UserEnvironmentSelectorUsersTable
            member={member}
            loadingUserEnvs={loadingUserEnvs}
            userEnvs={userEnvs}
            enableToggle={enableToggle}
            onUserEnvAccessUpdate={onUserEnvAccessUpdate}
          />
        )}
      </div>
      <DialogActionsWrapper>
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
        <Button onClick={onClose}>Save</Button>
      </DialogActionsWrapper>
    </Dialog>
  );
}
